import request from 'utils/request'
import { MCBCS030MonitorRequest } from 'types/MCBCS030/MCBCS030MonitorRequest'

export const monitorApi = (apiData: MCBCS030MonitorRequest) =>
  request({
    url: "/MCBCS030/monitor",
    method: 'post',
    data: apiData,
  })
